import { llmThreadLiteSchema } from "@redotech/redo-model/agents/llm-thread-lite";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAskRedoChildThreads = {
  name: "getAskRedoChildThreads" as const,
  input: z.object({ parentThreadId: zExt.objectId() }),
  output: z.object({
    data: z.array(llmThreadLiteSchema),
    totalCount: z.number(),
  }),
};
